import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=d229578c"
import script from "./StepFour.vue?vue&type=script&lang=js"
export * from "./StepFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports